import { Menu, X } from 'lucide-react'
import { useState } from 'react'

interface HeaderProps {
  siteName: string
  siteDescription: string
}

export default function Header({ siteName, siteDescription }: HeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const navigation: Array<{name: string; href: string}> = []

  return (
    <header className="bg-white/80 backdrop-blur-sm border-b border-glacier-100 sticky top-0 z-50">
      <nav className="container-padding mx-auto max-w-7xl">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 bg-gradient-to-br from-glacier-400 to-glacier-600 rounded-lg"></div>
                <div>
                  <h1 className="text-xl font-bold text-glacier-900">{siteName}</h1>
                  <p className="text-xs text-glacier-600">{siteDescription}</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-glacier-700 hover:text-glacier-900 px-3 py-2 text-sm font-medium transition-colors"
                >
                  {item.name}
                </a>
              ))}
            </div>
          </div>
          
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-glacier-700 hover:text-glacier-900 hover:bg-glacier-50"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
        
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-glacier-700 hover:text-glacier-900 block px-3 py-2 text-base font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </a>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  )
}